import { graphql } from '@/gql';
import type { DownloadRidesByDeactivatedPartnerCallersQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const downloadRidesByDeactivatedPartnerCallers = async ({
  to,
  from,
  partnerId,
}: DownloadRidesByDeactivatedPartnerCallersQueryVariables): Promise<string> => {
  const response = await queryExecute({
    query: graphql(`
      query downloadRidesByDeactivatedPartnerCallers($to: String!, $from: String!, $partnerId: Float!) {
        downloadRidesByDeactivatedPartnerCallers(to: $to, from: $from, partnerId: $partnerId)
      }
    `),
    fetchPolicy: 'no-cache',
    variables: {
      to,
      from,
      partnerId,
    },
  });

  return response.data.downloadRidesByDeactivatedPartnerCallers;
};
